/**
 * Cat weight collection filter (ported from production main-collection inline script).
 * Depends on jQuery (loaded in theme.liquid). No-ops when config script is absent.
 *
 * Tradeoff with native facets: facets forms use collection.url as action so price filters work.
 * Changing price (or other facets) drops the /collections/handle/WEIGHT path until weight is applied again.
 */
(function () {
  var activeCatWeight = null;
  var catWeightErrorValue = null;
  var skipNextWeightFocusout = false;

  function readConfig() {
    var script = document.querySelector('script[type="application/json"][id^="CollectionWeightConfig-"]');
    if (!script || !script.textContent) return null;
    try {
      return JSON.parse(script.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function getSection(config) {
    return document.getElementById('shopify-section-' + config.sectionId);
  }

  function jqueryLiveScopeFromConfig(cfg) {
    var $ = window.jQuery;
    if (!$ || !cfg || !cfg.sectionId) return $();
    var section = getSection(cfg);
    var elements = [];
    if (section) elements.push(section);

    var drawer = document.getElementById('facets-drawer');
    if (drawer && (!section || !section.contains(drawer))) {
      elements.push(drawer);
    }

    return $(elements);
  }

  function syncWeightNumbers($scope, weight) {
    $scope.find('.js-cat-weight-number').val(weight);
  }

  function setWeightInputsInvalid($scope, invalid) {
    $scope.find('.js-cat-weight-number').attr('aria-invalid', invalid ? 'true' : 'false');
  }

  function catWeightErrorText(errorElement, weight) {
    var template = errorElement.getAttribute('data-cat-weight-error-template') || '';
    return template.split('__WEIGHT__').join(String(weight) + ' LBS');
  }

  function showCatWeightError($scope, weight) {
    $scope.find('[data-cat-weight-error]').each(function () {
      this.textContent = catWeightErrorText(this, weight);
      this.hidden = false;
    });
    setWeightInputsInvalid($scope, true);
  }

  function hideCatWeightError($scope) {
    $scope.find('[data-cat-weight-error]').each(function () {
      this.textContent = '';
      this.hidden = true;
    });
    setWeightInputsInvalid($scope, false);
  }

  function weightIsAvailable(config, weight) {
    if (!config || !Array.isArray(config.availableWeights)) return true;
    return config.availableWeights.indexOf(String(weight)) !== -1;
  }

  function parseWeightFromPath(basePath) {
    var path = window.location.pathname.replace(/\/$/, '');
    var base = (basePath || '').replace(/\/$/, '');
    if (!base || path === base) return null;
    if (path.indexOf(base + '/') === 0) {
      var rest = path.slice(base.length + 1).split('/')[0];
      if (/^\d+$/.test(rest)) return parseInt(rest, 10);
    }
    return null;
  }

  function weightPath(base, weight) {
    var w = parseInt(weight, 10);
    if (isNaN(w) || w < 8) return base;
    return base + '/' + w;
  }

  function committedWeight(value) {
    var raw = value == null ? '' : String(value).trim();
    if (raw === '') return null;
    var w = parseInt(raw, 10);
    if (isNaN(w)) return null;
    return Math.max(8, w);
  }

  function buildUrl(pathname, config) {
    var u = new URL(pathname, window.location.origin);
    var cur = new URLSearchParams(window.location.search);
    cur.delete('page');
    cur.forEach(function (v, k) {
      u.searchParams.set(k, v);
    });
    u.searchParams.set('section_id', String(config.sectionId));
    return u.toString();
  }

  function buildDisplayUrl(fetchUrl, config) {
    var displayUrl = new URL(fetchUrl.toString(), window.location.origin);
    displayUrl.searchParams.delete('section_id');
    return displayUrl;
  }

  function normalizePath(pathname) {
    return (pathname || '').replace(/\/$/, '');
  }

  function pathIsCollectionBase(pathname, basePath) {
    var base = normalizePath(basePath);
    if (!base) return false;
    return normalizePath(pathname) === base;
  }

  function facetUpdateClearsAll(event, nextUrl, base) {
    var target = event.target;
    if (!target || !target.closest) return false;

    var facetLink = target.matches && target.matches('facet-link') ? target : target.closest('facet-link');
    var link = facetLink ? facetLink.querySelector('a[href]') : target.closest('a[href]');
    if (!link) return false;
    if (link.closest('.removable-facet')) return false;
    if (link.matches('[data-collection-reset], .facets-clear-all')) return true;

    var resetUrl = new URL(link.href, window.location.origin);
    resetUrl.searchParams.set('section_id', nextUrl.searchParams.get('section_id') || '');
    return pathIsCollectionBase(resetUrl.pathname, base) && resetUrl.searchParams.toString() === nextUrl.searchParams.toString();
  }

  function clearCatWeightState() {
    activeCatWeight = null;
    catWeightErrorValue = null;
  }

  function isMobileCollectionToolbar() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function setCatWeightFacetActive($section, active) {
    $section.find('[data-cat-weight-facet]').attr('data-cat-weight-active', active ? 'true' : 'false');
  }

  function setCatWeightResultsInvalid(config, invalid) {
    var section = getSection(config);
    if (!section) return;

    var emptyState = section.querySelector('[data-cat-weight-empty-state]');
    var collectionMain = section.querySelector('.collection__main');
    if (emptyState) emptyState.hidden = !invalid;
    if (collectionMain) collectionMain.hidden = invalid;
  }

  function updateCatWeightToolbar($scope, active) {
    $scope.find('[data-cat-weight-toolbar-button]').each(function () {
      var nativeCount = parseInt(this.getAttribute('data-native-filter-count') || '0', 10);
      var totalCount = nativeCount + (active ? 1 : 0);
      var count = this.querySelector('[data-cat-weight-toolbar-count]');
      if (!count) return;
      count.textContent = '(' + totalCount + ')';
      count.hidden = totalCount === 0;
    });

    $scope.find('[data-cat-weight-toolbar-reset]').each(function () {
      var container = this.parentElement;
      var button = container ? container.querySelector('[data-cat-weight-toolbar-button]') : null;
      var nativeCount = button ? parseInt(button.getAttribute('data-native-filter-count') || '0', 10) : 0;
      this.hidden = nativeCount + (active ? 1 : 0) === 0;
    });
  }

  function updateSearchView(weight, config) {
    if (!window.jQuery) return;
    var base = (config.collectionBasePath || '').replace(/\/$/, '');
    var path = weightPath(base, weight);
    var fetchUrl = buildUrl(path, config);
    var section = getSection(config);
    if (!section) return;
    var displayUrl = buildDisplayUrl(fetchUrl, config);

    section.dispatchEvent(
      new CustomEvent('facet:update', {
        bubbles: true,
        detail: {
          url: new URL(fetchUrl),
          displayUrl: displayUrl,
          catWeightRequest: true,
        },
      })
    );
  }

  function updateResetView(resetHref, config) {
    var section = getSection(config);
    if (!section) return;

    var fetchUrl = new URL(resetHref, window.location.origin);
    fetchUrl.searchParams.set('section_id', String(config.sectionId));
    section.dispatchEvent(
      new CustomEvent('facet:update', {
        bubbles: true,
        detail: {
          url: fetchUrl,
          displayUrl: buildDisplayUrl(fetchUrl, config),
          catWeightRequest: true,
        },
      })
    );
  }

  function sectionHasNoProducts(config) {
    var section = getSection(config);
    if (!section) return false;
    if (!section.querySelector('.collection__main')) return true;
    if (section.querySelector('[data-cat-weight-empty-state]:not([hidden])')) return true;
    return Boolean(section.querySelector('.empty-state:not([hidden])')) && !section.querySelector('product-list product-card');
  }

  function bindPriceActiveListeners($, $section, config) {
    if (!config.priceMinParam || !config.priceMaxParam) return;
    var minSel = '[name="' + config.priceMinParam.replace(/"/g, '\\"') + '"]';
    var maxSel = '[name="' + config.priceMaxParam.replace(/"/g, '\\"') + '"]';
    $section.find(minSel + ',' + maxSel).off('input.catWeightPrice change.catWeightPrice');
    $section.find(minSel + ',' + maxSel).on('input.catWeightPrice change.catWeightPrice', function () {
      var minEl = $section.find(minSel).get(0);
      var maxEl = $section.find(maxSel).get(0);
      if (!minEl || !maxEl) return;
      var priceMin = parseFloat(minEl.value || '0', 10);
      var priceMax = parseFloat(maxEl.value || '0', 10);
      var defaultMax = parseFloat(maxEl.getAttribute('max') || '0', 10);
      var $priceRange = $(minEl).closest('.price-range');
      var $wrap = $priceRange.closest('accordion-disclosure, .accordion');
      if (priceMin > 0 || (priceMax > 0 && defaultMax > 0 && priceMax < defaultMax)) {
        $wrap.attr('data-price-facet-active', 'true');
      } else {
        $wrap.attr('data-price-facet-active', 'false');
      }
    });
  }

  function initCatWeight($, config) {
    var $scope = jqueryLiveScopeFromConfig(config);
    if (!$scope.length || !$scope.find('.js-cat-weight-number').length) return;

    var fromPath = parseWeightFromPath(config.collectionBasePath);
    if (catWeightErrorValue != null) {
      syncWeightNumbers($scope, catWeightErrorValue);
      setCatWeightFacetActive($scope, true);
      updateCatWeightToolbar($scope, true);
      setCatWeightResultsInvalid(config, true);
      showCatWeightError($scope, catWeightErrorValue);
    } else if (activeCatWeight != null) {
      var activeWeightUnavailable = !weightIsAvailable(config, activeCatWeight);
      var activeWeightHasNoProducts = sectionHasNoProducts(config);
      syncWeightNumbers($scope, activeCatWeight);
      setCatWeightFacetActive($scope, true);
      updateCatWeightToolbar($scope, true);
      setCatWeightResultsInvalid(config, activeWeightUnavailable || activeWeightHasNoProducts);
      if (activeWeightUnavailable || activeWeightHasNoProducts) {
        showCatWeightError($scope, activeCatWeight);
      } else {
        hideCatWeightError($scope);
      }
    } else if (fromPath != null && !isNaN(fromPath)) {
      var pathWeightUnavailable = !weightIsAvailable(config, fromPath);
      var pathWeightHasNoProducts = sectionHasNoProducts(config);
      activeCatWeight = fromPath;
      syncWeightNumbers($scope, activeCatWeight);
      setCatWeightFacetActive($scope, true);
      updateCatWeightToolbar($scope, true);
      setCatWeightResultsInvalid(config, pathWeightUnavailable || pathWeightHasNoProducts);
      if (pathWeightUnavailable || pathWeightHasNoProducts) {
        catWeightErrorValue = activeCatWeight;
        showCatWeightError($scope, activeCatWeight);
      } else {
        hideCatWeightError($scope);
      }
    } else {
      syncWeightNumbers($scope, '');
      setCatWeightFacetActive($scope, false);
      updateCatWeightToolbar($scope, false);
      setCatWeightResultsInvalid(config, sectionHasNoProducts(config));
      hideCatWeightError($scope);
    }

    bindPriceActiveListeners($, $scope, config);
  }

  function main() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var config = readConfig();
    if (!config || !config.sectionId) return;

    $(function () {
      initCatWeight($, readConfig() || config);
    });

    var onFacetLoadingEnd = function () {
      var cfg = readConfig();
      if (!cfg) return;
      setTimeout(function () {
        initCatWeight($, readConfig() || cfg);
      }, 0);
    };
    if (!window.__maupetsCatWeightThemeHook) {
      window.__maupetsCatWeightThemeHook = true;
      document.documentElement.addEventListener('theme:loading:end', onFacetLoadingEnd);
    }

    function refreshActiveState($scope, config, weight) {
      var active = !isNaN(weight) && weight >= 8;
      setCatWeightFacetActive($scope, active);
      updateCatWeightToolbar($scope, active);
    }

    function handleNumberInput(elm) {
      var cfg = readConfig();
      if (!cfg) return;
      var $scope = jqueryLiveScopeFromConfig(cfg);
      if (!$scope.length) return;
      syncWeightNumbers($scope, $(elm).val());
      hideCatWeightError($scope);
    }

    function handleNumberCommit(elm) {
      var cfg = readConfig();
      if (!cfg) return;
      var $scope = jqueryLiveScopeFromConfig(cfg);
      if (!$scope.length) return;
      var currentVal = $(elm).val();
      var w = committedWeight(currentVal);
      if (w == null) {
        activeCatWeight = null;
        catWeightErrorValue = null;
        syncWeightNumbers($scope, '');
        refreshActiveState($scope, cfg, NaN);
        setCatWeightResultsInvalid(cfg, false);
        hideCatWeightError($scope);
        updateSearchView(null, cfg);
        return;
      }
      activeCatWeight = w;
      catWeightErrorValue = null;
      syncWeightNumbers($scope, w);
      refreshActiveState($scope, cfg, w);
      hideCatWeightError($scope);
      updateSearchView(w, cfg);
    }

    function blurAfterSubmit(elm) {
      if (document.activeElement !== elm || typeof elm.blur !== 'function') return;
      skipNextWeightFocusout = true;
      elm.blur();
    }

    document.addEventListener(
      'facet:update',
      function (event) {
        if (!event.detail || event.detail.catWeightRequest) return;
        var cfg = readConfig();
        if (!cfg) return;

        var nextUrl = new URL(event.detail.url.toString(), window.location.origin);
        var base = (cfg.collectionBasePath || '').replace(/\/$/, '');

        if (facetUpdateClearsAll(event, nextUrl, base)) {
          clearCatWeightState();
          setCatWeightResultsInvalid(cfg, false);
          hideCatWeightError(jqueryLiveScopeFromConfig(cfg));
          return;
        }

        if (catWeightErrorValue != null) {
          clearCatWeightState();
          setCatWeightResultsInvalid(cfg, false);
          hideCatWeightError(jqueryLiveScopeFromConfig(cfg));
          return;
        }

        if (activeCatWeight == null) return;
        nextUrl.pathname = weightPath(base, activeCatWeight);
        event.detail.url = nextUrl;
        event.detail.displayUrl = buildDisplayUrl(nextUrl, cfg);
        event.detail.catWeightRequest = true;
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        if (!isMobileCollectionToolbar()) return;
        var resetLink = event.target.closest('[data-collection-reset]');
        if (!resetLink) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        clearCatWeightState();
        var cfg = readConfig();
        if (cfg) {
          var $scope = jqueryLiveScopeFromConfig(cfg);
          syncWeightNumbers($scope, '');
          setCatWeightFacetActive($scope, false);
          updateCatWeightToolbar($scope, false);
          setCatWeightResultsInvalid(cfg, false);
          hideCatWeightError($scope);
          updateResetView(resetLink.href, cfg);
        }
      },
      true
    );

    document.addEventListener(
      'input',
      function (event) {
        var target = event.target;
        if (!target || !target.closest || !target.closest('[data-cat-weight-control]')) return;
        event.stopPropagation();
        if (target.matches('.js-cat-weight-number')) {
          handleNumberInput(target);
        }
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!target || !target.closest || !target.closest('[data-cat-weight-control]')) return;
        event.stopPropagation();
        if (target.matches('.js-cat-weight-number')) {
          handleNumberCommit(target);
          blurAfterSubmit(target);
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (event) {
        var target = event.target;
        if (!target || !target.matches || !target.matches('.js-cat-weight-number') || event.key !== 'Enter') return;
        event.preventDefault();
        event.stopPropagation();
        handleNumberCommit(target);
        blurAfterSubmit(target);
      },
      true
    );

    document.addEventListener(
      'focusout',
      function (event) {
        var target = event.target;
        if (!target || !target.matches || !target.matches('.js-cat-weight-number')) return;
        if (skipNextWeightFocusout) {
          skipNextWeightFocusout = false;
          return;
        }
        handleNumberCommit(target);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
